MembersAccordionList.jsx; // src/sectors/pilates/members/components/MembersAccordionList.jsx
import React from 'react';
import MDBox from 'components/MDBox';
import { MembersAccordionItem } from './MembersAccordionItem';

export function MembersAccordionList({ items, onDetail, onOpenMenu }) {
  const [expandedId, setExpandedId] = React.useState(null);
  const handleToggle = (nextIdOrNull) => setExpandedId(nextIdOrNull);

  return (
    <MDBox sx={{ display: 'grid', gap: 1.25 }}>
      {(items || []).map((m) => (
        <MembersAccordionItem
          key={m.id}
          member={m}
          expanded={expandedId === m.id}
          onToggle={handleToggle}
          onOpenMenu={onOpenMenu}
          onDetail={onDetail}
        />
      ))}
    </MDBox>
  );
}
